/* Caveau - comportamenti dei componenti conversione:
   aggiunta rapida dei campioni, scelta dei campioni omaggio nel carrello (ricerca intelligente, foto e ×),
   richiesta su WhatsApp nella scheda prodotto. */
(() => {
  'use strict';
  if (window.__caveauConv) return;
  window.__caveauConv = true;

  const routes = window.routes || {};
  const ADD_URL = (routes.cart_add_url || '/cart/add') + '.js';
  const UPDATE_URL = (routes.cart_update_url || '/cart/update') + '.js';
  const CART_URL = routes.cart_url || '/cart';
  const DRAWER = '[data-line-items-drawer-container]';
  const PAGE = '[data-line-items-container]';
  const NOTE = 'textarea[data-cv-cart-note], textarea#Cart-note';

  /* ---------- Carrello: ridisegno dopo una modifica ---------- */

  // Nella pagina carrello la sezione ha un id generato dal template: lo leggiamo dal DOM,
  // così la pagina viene ridisegnata con le sue impostazioni reali.
  const cartSectionId = () => {
    const page = document.querySelector(PAGE);
    const wrap = page ? page.closest('.shopify-section') : null;
    return wrap && wrap.id ? wrap.id.replace('shopify-section-', '') : 'main-cart';
  };

  const drawerModal = () => document.querySelector('modal-component[data-modal="modal-cart-drawer"]');

  const renderCart = (markup) => {
    const doc = new DOMParser().parseFromString(markup, 'text/html');
    const template = doc.querySelector('template');
    const source = template ? template.content : doc;

    ['[data-cart-bubble]', '[data-cart-bubble-text]'].forEach((selector) => {
      const from = source.querySelector(selector);
      if (!from) return;
      document.querySelectorAll(selector).forEach((element) => {
        element.innerHTML = from.innerHTML;
      });
    });

    const drawer = document.querySelector(DRAWER);
    const drawerFrom = source.querySelector(DRAWER);
    if (drawer && drawerFrom) {
      const scroller = drawer.querySelector('.modal-component_content');
      const top = scroller ? scroller.scrollTop : 0;
      drawer.innerHTML = drawerFrom.innerHTML;
      const next = drawer.querySelector('.modal-component_content');
      if (next) next.scrollTop = top;
    }

    const page = document.querySelector(PAGE);
    const pageFrom = doc.querySelector(PAGE);
    if (page && pageFrom) page.innerHTML = pageFrom.innerHTML;

    const modal = drawerModal();
    if (modal && modal.classList.contains('modal--active') && typeof window.trapFocus === 'function' && modal.content) {
      window.trapFocus(modal.content);
    }
  };

  const openDrawer = () => {
    if (!drawerModal()) {
      if (window.location.pathname !== CART_URL) window.location.href = CART_URL;
      return;
    }
    const toggler = document.querySelector('[data-modal-ref="modal-cart-drawer"][data-expanded="false"]');
    if (toggler) toggler.dispatchEvent(new Event('click'));
  };

  /* ---------- Avviso "aggiunto al carrello" (pagina campioni) ---------- */

  let toastTimer = 0;
  const showToast = () => {
    const toast = document.querySelector('[data-cv-toast]');
    if (!toast) return;
    toast.hidden = false;
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => { toast.hidden = true; }, 5000);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest ? event.target.closest('[data-cv-toast-open]') : null;
    if (!trigger) return;
    const toast = trigger.closest('[data-cv-toast]');
    if (toast) toast.hidden = true;
    openDrawer();
  });

  /* ---------- Aggiunta rapida (campioni suggeriti, pagina campioni) ---------- */

  const setQuickError = (form, message) => {
    let box = form.parentNode.querySelector('.cv-quick-error');
    if (!message) {
      if (box) box.remove();
      return;
    }
    if (!box) {
      box = document.createElement('span');
      box.className = 'cv-quick-error';
      box.setAttribute('role', 'alert');
      form.insertAdjacentElement('afterend', box);
    }
    box.textContent = message;
  };

  const quickAdd = (form) => {
    if (form.dataset.cvBusy === '1') return;
    const button = form.querySelector('[type="submit"]');
    const label = button ? button.textContent : '';
    const section = cartSectionId();
    const body = new FormData(form);
    body.append('sections', section);
    body.append('sections_url', window.location.pathname);

    form.dataset.cvBusy = '1';
    if (button) {
      button.disabled = true;
      button.classList.add('is-busy');
    }
    setQuickError(form, '');

    fetch(ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || data.message || '');
        if (button && button.dataset.labelAdded) {
          button.textContent = button.dataset.labelAdded;
          button.classList.add('is-added');
        }
        const inCart = !!form.closest(DRAWER + ', ' + PAGE);
        if (data.sections && data.sections[section]) renderCart(data.sections[section]);
        if (form.hasAttribute('data-cv-open-cart')) openDrawer();
        else if (!inCart) showToast();
      })
      .catch((error) => {
        if (form.isConnected) setQuickError(form, (error && error.message) || form.dataset.errorText || '');
      })
      .finally(() => {
        window.setTimeout(() => {
          if (!form.isConnected) return;
          delete form.dataset.cvBusy;
          if (button) {
            button.disabled = false;
            button.classList.remove('is-busy', 'is-added');
            button.textContent = label;
          }
        }, 1500);
      });
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form || !form.matches || !form.matches('form[data-cv-quick-add]')) return;
    event.preventDefault();
    quickAdd(form);
  });

  /* ---------- Carrello: preferenze campioni (nota dell'ordine) ---------- */

  const note = { value: null, open: null, dirty: false, timer: 0, statusTimer: 0 };

  const noteFields = () => document.querySelectorAll(NOTE);

  const setNoteStatus = (saved) => {
    document.querySelectorAll('[data-cv-note-status]').forEach((element) => {
      element.textContent = saved ? element.dataset.savedText || '' : '';
    });
  };

  const saveNote = () => {
    window.clearTimeout(note.timer);
    if (!note.dirty) return;
    const value = note.value;
    note.dirty = false;
    fetch(UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value }),
      keepalive: true
    })
      .then((response) => {
        if (!response.ok) throw new Error('note');
        if (note.value !== value) return;
        setNoteStatus(true);
        window.clearTimeout(note.statusTimer);
        note.statusTimer = window.setTimeout(() => setNoteStatus(false), 2500);
      })
      .catch(() => {
        if (note.value === value) note.dirty = true;
      });
  };

  // Dopo un ridisegno del carrello il campo torna con il valore del server:
  // se il cliente stava scrivendo, rimettiamo il suo testo.
  const restoreNote = () => {
    if (note.open !== null) {
      document.querySelectorAll('[data-cv-note-details]').forEach((details) => {
        if (details.open !== note.open) details.open = note.open;
      });
    }
    if (note.value !== null) {
      noteFields().forEach((field) => {
        if (field.value !== note.value) field.value = note.value;
      });
    }
    enhanceNotes();
  };

  // Il riquadro delle preferenze resta aperto o chiuso come l'ha lasciato il cliente.
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (details && details.matches && details.matches('[data-cv-note-details]')) note.open = details.open;
  }, true);

  document.addEventListener('input', (event) => {
    const field = event.target;
    if (!field || !field.matches || !field.matches(NOTE)) return;
    note.value = field.value;
    note.dirty = true;
    noteFields().forEach((other) => {
      if (other !== field && other.value !== note.value) other.value = note.value;
    });
    setNoteStatus(false);
    window.clearTimeout(note.timer);
    note.timer = window.setTimeout(saveNote, 700);
  });

  document.addEventListener('change', (event) => {
    const field = event.target;
    if (field && field.matches && field.matches(NOTE)) saveNote();
  });

  window.addEventListener('pagehide', saveNote);

  /* ---------- Carrello: scelta dei campioni omaggio con ricerca intelligente ----------
     Il cliente scrive il nome di un profumo o di una maison nella casella di ricerca: sotto compaiono i profumi disponibili
     (sections/caveau-sample-suggest.liquid): quelli con il formato 2 ml con la foto del campione e "formato 2 ml", quelli
     senza (es. Creed, Xerjoff) solo con nome e maison, ma si scelgono allo stesso modo. Quello scelto resta nel riquadro con
     nome, "Selezionato" e una × per toglierlo. La nota dell'ordine (campo nascosto "note") contiene i campioni scelti, uno per
     riga ("Nome – Maison"), e si salva da sola come prima. Senza JavaScript resta il campo di testo normale. */

  const PICK_SEP = /[\n,;]/;
  const DASH = ' ' + String.fromCharCode(8211) + ' ';
  const DOT = ' ' + String.fromCharCode(183) + ' ';
  const TIMES = String.fromCharCode(215);
  const MARKS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  const pick = { input: null, box: null, items: [], active: -1, timer: 0, controller: null, seq: 0, cache: new Map(), image: '' };
  // Su telefono la ricerca si apre a tutto schermo, sopra la tastiera (vedi openSheet).
  const sheetQuery = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  const sheet = { picker: null };

  // Minuscole senza accenti, un carattere per carattere (così le posizioni restano le stesse del testo originale).
  const foldChar = (ch) => {
    const base = ch.normalize('NFD').replace(MARKS, '').charAt(0) || ch;
    const lower = base.toLowerCase();
    return lower.length === 1 ? lower : ch;
  };
  const fold = (text) => Array.from(String(text || '')).map(foldChar).join('');
  const wordsOf = (text) => fold(text).split(/[^0-9a-z#]+/).filter(Boolean);
  const allMatch = (query, words) => query.every((part) => words.some((word) => word.startsWith(part)));
  // I testi arrivano dal tema con i segnaposto [n], [m], [v] (le graffe non si possono usare dentro {{ }}).
  const fill = (text, values) => String(text || '').replace(/\[(\w)\]/g, (all, key) => (key in values ? values[key] : all));

  const noteEntries = (value) => String(value || '').split(PICK_SEP).map((part) => part.trim()).filter(Boolean);
  const parseEntry = (line) => {
    const at = line.lastIndexOf(DASH);
    return at > 0 ? { name: line.slice(0, at).trim(), vendor: line.slice(at + DASH.length).trim() } : { name: line, vendor: '' };
  };
  const labelFor = (item) => (item.vendor ? item.name + DASH + item.vendor : item.name);

  // Quali campioni scelti non hanno il formato 2 ml (nella scheda: niente foto e niente "formato 2 ml").
  // La nota contiene solo "Nome – Maison": l'informazione resta in questo browser (localStorage), per i ridisegni del carrello.
  const KINDS_KEY = 'cv-pick-kinds';
  const kindKey = (name, vendor) => fold(name + '|' + vendor);
  const loadKinds = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(KINDS_KEY) || '{}');
      return value && typeof value === 'object' ? value : {};
    } catch (error) {
      return {};
    }
  };
  const kinds = loadKinds();
  const saveKinds = (entries) => {
    const keep = {};
    entries.forEach((line) => {
      const entry = parseEntry(line);
      const key = kindKey(entry.name, entry.vendor);
      if (key in kinds) keep[key] = kinds[key];
    });
    Object.keys(kinds).forEach((key) => {
      if (!(key in keep)) delete kinds[key];
    });
    try {
      window.localStorage.setItem(KINDS_KEY, JSON.stringify(keep));
    } catch (error) {
      /* niente spazio o archiviazione non disponibile: la scheda mostrerà la foto del campione */
    }
  };
  const noSampleOf = (entry) => kinds[kindKey(entry.name, entry.vendor)] === 0;
  // Segnaposto al posto della foto per i profumi senza formato 2 ml (stessa misura, così l'elenco resta allineato).
  const sampleSpot = (className) => {
    const box = document.createElement('span');
    box.className = className;
    box.setAttribute('aria-hidden', 'true');
    return box;
  };

  const wrapOf = (element) => (element && element.closest ? element.closest('.cv-cartnote') : null);
  const fieldOf = (wrap) => (wrap ? wrap.querySelector(NOTE) : null);
  const inputOf = (wrap) => (wrap ? wrap.querySelector('[data-cv-pick-input]') : null);
  const boxOf = (wrap) => (wrap ? wrap.querySelector('[data-cv-pick]') : null);
  const maxOf = (field) => parseInt((field && field.dataset.cvPickMax) || '0', 10) || 0;

  const refreshNoteCount = (wrap) => {
    const field = fieldOf(wrap);
    const counter = wrap ? wrap.querySelector('[data-cv-note-count]') : null;
    if (!field || !counter) return;
    const max = maxOf(field);
    const count = noteEntries(field.value).length;
    let text = '';
    if (max > 0 && count > 0) {
      let template = counter.dataset.text;
      if (count > max) template = counter.dataset.textOver;
      else if (count === max) template = counter.dataset.textFull;
      text = fill(template, { n: count, m: max });
    }
    if (counter.textContent !== text) counter.textContent = text;
    counter.classList.toggle('is-over', max > 0 && count > max);
    const short = wrap.querySelector('[data-cv-sheet-count]');
    if (short) {
      const value = max > 0 ? fill(short.dataset.text, { n: count, m: max }) : '';
      if (short.textContent !== value) short.textContent = value;
    }
  };

  // I campioni scelti, ridisegnati dal contenuto della nota (anche dopo un aggiornamento del carrello).
  const renderChips = (wrap) => {
    const field = fieldOf(wrap);
    const list = wrap ? wrap.querySelector('[data-cv-chips]') : null;
    const input = inputOf(wrap);
    const box = boxOf(wrap);
    if (!field || !list || !input || !box) return;
    const entries = noteEntries(field.value);
    const key = entries.join('\n');
    if (list.dataset.key !== key || list.childElementCount !== entries.length) {
      list.dataset.key = key;
      list.textContent = '';
      entries.forEach((line, index) => {
        const entry = parseEntry(line);
        const noSample = noSampleOf(entry);
        const chip = document.createElement('li');
        chip.className = 'cv-chip' + (noSample ? ' cv-chip--text' : '');

        if (noSample) {
          chip.appendChild(sampleSpot('cv-chip__ph'));
        } else {
          const image = document.createElement('img');
          image.className = 'cv-chip__img';
          image.alt = '';
          image.width = 40;
          image.height = 40;
          const src = box.dataset.image || pick.image;
          if (src) image.src = src;
          chip.appendChild(image);
        }

        const text = document.createElement('span');
        text.className = 'cv-chip__text';
        const name = document.createElement('span');
        name.className = 'cv-chip__name';
        name.textContent = entry.name;
        const meta = document.createElement('span');
        meta.className = 'cv-chip__meta';
        const ok = document.createElement('span');
        ok.className = 'cv-chip__ok';
        ok.textContent = box.dataset.textSelected || '';
        meta.appendChild(ok);
        const rest = [noSample ? '' : box.dataset.textFormat || '', entry.vendor].filter(Boolean).join(DOT);
        if (rest) meta.appendChild(document.createTextNode(DOT + rest));
        text.appendChild(name);
        text.appendChild(meta);
        chip.appendChild(text);

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cv-chip__remove';
        remove.setAttribute('data-cv-chip-remove', String(index));
        remove.setAttribute('aria-label', (box.dataset.textRemove || '') + ' ' + entry.name);
        remove.textContent = TIMES;
        chip.appendChild(remove);
        list.appendChild(chip);
      });
    }
    const max = maxOf(field);
    const full = max > 0 && entries.length >= max;
    if (input.disabled !== full) input.disabled = full;
    const placeholder = full ? input.dataset.placeholderFull : input.dataset.placeholder;
    if (placeholder && input.placeholder !== placeholder) input.placeholder = placeholder;
    refreshNoteCount(wrap);
  };

  // Con JavaScript attivo il campo di testo lascia il posto alla scelta con ricerca.
  function enhanceNotes() {
    if (sheet.picker && !sheet.picker.isConnected) closeSheet(false);
    document.querySelectorAll('.cv-cartnote').forEach((wrap) => {
      const picker = wrap.querySelector('[data-cv-picker]');
      if (!picker || !fieldOf(wrap)) return;
      if (!wrap.classList.contains('is-enhanced')) {
        wrap.classList.add('is-enhanced');
        picker.hidden = false;
      }
      renderChips(wrap);
    });
  }

  // Scrive la nota (stessa strada del campo di testo: salvataggio automatico) e aggiorna tutti i riquadri.
  const writeNote = (field, entries) => {
    saveKinds(entries);
    field.value = entries.join('\n');
    field.dispatchEvent(new Event('input', { bubbles: true }));
    enhanceNotes();
  };

  const setActive = (index) => {
    pick.active = index;
    pick.items.forEach((entry, i) => {
      const on = i === index;
      entry.node.classList.toggle('is-active', on);
      entry.node.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (!pick.input) return;
    const entry = pick.items[index];
    if (entry) {
      pick.input.setAttribute('aria-activedescendant', entry.node.id);
      const list = entry.node.parentNode;
      const frame = list.getBoundingClientRect();
      const rect = entry.node.getBoundingClientRect();
      if (rect.top < frame.top) list.scrollTop -= frame.top - rect.top;
      else if (rect.bottom > frame.bottom) list.scrollTop += rect.bottom - frame.bottom;
    } else {
      pick.input.removeAttribute('aria-activedescendant');
    }
  };

  const closePick = () => {
    window.clearTimeout(pick.timer);
    pick.seq += 1;
    if (pick.controller) pick.controller.abort();
    pick.controller = null;
    if (pick.box) {
      pick.box.hidden = true;
      const picker = pick.box.closest('[data-cv-picker]');
      if (picker) picker.classList.remove('is-searching');
    }
    if (pick.input) {
      pick.input.setAttribute('aria-expanded', 'false');
      pick.input.removeAttribute('aria-activedescendant');
    }
    pick.items = [];
    pick.active = -1;
  };

  const showPick = (box, input) => {
    box.hidden = false;
    const picker = box.closest('[data-cv-picker]');
    if (picker) picker.classList.add('is-searching');
    input.setAttribute('aria-expanded', 'true');
  };

  const pickStatus = (box, input, text) => {
    const head = box.querySelector('[data-cv-pick-head]');
    const list = box.querySelector('[data-cv-pick-list]');
    const status = box.querySelector('[data-cv-pick-status]');
    if (head) head.hidden = true;
    if (list) list.textContent = '';
    if (status) status.textContent = text || '';
    pick.items = [];
    setActive(-1);
    if (text) showPick(box, input);
    else closePick();
  };

  const fetchSamples = (box, term) => {
    const key = fold(term).replace(/\s+/g, ' ');
    if (pick.cache.has(key)) return Promise.resolve(pick.cache.get(key));
    if (pick.controller) pick.controller.abort();
    const controller = new AbortController();
    pick.controller = controller;
    const url = (box.dataset.url || '/search') + '?q=' + encodeURIComponent(term) +
      '&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide&section_id=caveau-sample-suggest';
    return fetch(url, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error('search');
        return response.text();
      })
      .then((markup) => {
        const doc = new DOMParser().parseFromString(markup, 'text/html');
        const seen = new Map();
        const list = [];
        doc.querySelectorAll('[data-cv-suggest-item]').forEach((node) => {
          const item = {
            name: node.dataset.name || '',
            vendor: node.dataset.vendor || '',
            image: node.dataset.image || '',
            sample: node.dataset.sample !== '0'
          };
          const id = kindKey(item.name, item.vendor);
          if (!item.name) return;
          // Stesso profumo in più formati: una voce sola, quella con il formato 2 ml se c'è.
          if (seen.has(id)) {
            const at = seen.get(id);
            if (item.sample && !list[at].sample) list[at] = item;
            return;
          }
          seen.set(id, list.length);
          list.push(item);
        });
        if (pick.cache.size > 60) pick.cache.clear();
        pick.cache.set(key, list);
        return list;
      });
  };

  // Ordine: se il testo è il nome di una maison, tutti i suoi campioni in ordine alfabetico;
  // altrimenti prima i nomi che iniziano con il testo scritto. Le parole valgono anche a metà ("bois imp").
  const rankSamples = (term, list) => {
    const query = wordsOf(term);
    if (!query.length) return { items: [], brand: '' };
    const start = fold(term).trim();
    const scored = [];
    list.forEach((item, index) => {
      const nameWords = wordsOf(item.name);
      const vendorWords = wordsOf(item.vendor);
      if (!allMatch(query, nameWords.concat(vendorWords))) return;
      scored.push({
        item,
        index,
        inVendor: allMatch(query, vendorWords),
        inName: allMatch(query, nameWords),
        starts: fold(item.name).startsWith(start)
      });
    });
    // Se il negozio trova qualcosa che il filtro non riconosce (es. un errore di battitura), si mostra comunque.
    const pool = scored.length ? scored : list.map((item, index) => ({ item, index, inVendor: false, inName: false, starts: false }));
    const vendors = new Set(pool.map((entry) => entry.item.vendor));
    const brand = scored.length > 0 && vendors.size === 1 && scored.every((entry) => entry.inVendor && !entry.inName);
    if (brand) {
      pool.sort((a, b) => a.item.name.localeCompare(b.item.name, 'it'));
    } else {
      pool.sort((a, b) => (Number(b.starts) - Number(a.starts)) || (Number(b.inName) - Number(a.inName)) || (a.index - b.index));
    }
    return { items: pool.slice(0, 200).map((entry) => entry.item), brand: brand ? pool[0].item.vendor : '' };
  };

  // Mette in grassetto le parole cercate nel nome.
  const writeHighlighted = (target, text, query) => {
    const chars = Array.from(text);
    const folded = chars.map(foldChar).join('');
    const marks = new Array(chars.length).fill(false);
    if (folded.length === chars.length) {
      query.forEach((part) => {
        let from = 0;
        while (from < folded.length) {
          const at = folded.indexOf(part, from);
          if (at === -1) break;
          if (at === 0 || /[^0-9a-z#]/.test(folded.charAt(at - 1))) {
            for (let k = at; k < at + part.length; k += 1) marks[k] = true;
            break;
          }
          from = at + 1;
        }
      });
    }
    let buffer = '';
    let bold = false;
    const flush = () => {
      if (!buffer) return;
      if (bold) {
        const strong = document.createElement('b');
        strong.textContent = buffer;
        target.appendChild(strong);
      } else {
        target.appendChild(document.createTextNode(buffer));
      }
      buffer = '';
    };
    chars.forEach((ch, k) => {
      if (marks[k] !== bold) {
        flush();
        bold = marks[k];
      }
      buffer += ch;
    });
    flush();
  };

  const renderPick = (input, box, term, result) => {
    const wrap = wrapOf(input);
    const field = fieldOf(wrap);
    const head = box.querySelector('[data-cv-pick-head]');
    const list = box.querySelector('[data-cv-pick-list]');
    const status = box.querySelector('[data-cv-pick-status]');
    if (!list || !field) return;
    if (!result.items.length) {
      pickStatus(box, input, box.dataset.textEmpty || '');
      return;
    }
    const chosen = noteEntries(field.value).map((line) => fold(parseEntry(line).name));
    const max = maxOf(field);
    const full = max > 0 && chosen.length >= max;
    const query = wordsOf(term);

    list.textContent = '';
    pick.items = [];
    result.items.forEach((item, i) => {
      if (item.image && !pick.image) pick.image = item.image;
      const already = chosen.some((name) => name === fold(item.name));
      const node = document.createElement('li');
      node.className = 'cv-pick__item' + (item.sample ? '' : ' cv-pick__item--text');
      node.id = list.id + '-' + i;
      node.setAttribute('role', 'option');
      node.setAttribute('aria-selected', 'false');
      if (already || full) node.setAttribute('aria-disabled', 'true');

      if (item.sample) {
        const image = document.createElement('img');
        image.alt = '';
        image.width = 44;
        image.height = 44;
        image.loading = 'lazy';
        if (item.image) image.src = item.image;
        node.appendChild(image);
      } else {
        node.appendChild(sampleSpot('cv-pick__ph'));
      }

      const text = document.createElement('span');
      text.className = 'cv-pick__text';
      const name = document.createElement('span');
      name.className = 'cv-pick__name';
      writeHighlighted(name, item.name, query);
      const meta = document.createElement('span');
      meta.className = 'cv-pick__meta';
      meta.textContent = [item.sample ? box.dataset.textFormat || '' : '', item.vendor].filter(Boolean).join(DOT);
      text.appendChild(name);
      text.appendChild(meta);
      node.appendChild(text);

      if (already) {
        const tag = document.createElement('span');
        tag.className = 'cv-pick__tag';
        tag.textContent = box.dataset.textChosen || '';
        node.appendChild(tag);
      }
      list.appendChild(node);
      pick.items.push({ node, item, disabled: already || full });
    });

    if (head) {
      const brandText = result.brand ? fill(box.dataset.textBrand, { v: result.brand, n: result.items.length }) : '';
      head.textContent = brandText;
      head.hidden = !brandText;
    }
    if (status) status.textContent = full ? fill(box.dataset.textFull, { n: max }) : '';
    showPick(box, input);
    list.scrollTop = 0;
    setActive(pick.items.findIndex((entry) => !entry.disabled));
  };

  const runPick = (input, box, term) => {
    const seq = ++pick.seq;
    fetchSamples(box, term)
      .then((list) => {
        if (seq !== pick.seq || !input.isConnected || input.value.trim() !== term) return;
        renderPick(input, box, term, rankSamples(term, list));
      })
      .catch((error) => {
        if ((error && error.name === 'AbortError') || seq !== pick.seq || !input.isConnected) return;
        pickStatus(box, input, box.dataset.textError || '');
      });
  };

  const schedulePick = (input) => {
    const box = boxOf(wrapOf(input));
    if (!box) return;
    if (pick.input && pick.input !== input) closePick();
    pick.input = input;
    pick.box = box;
    window.clearTimeout(pick.timer);
    const term = input.value.trim();
    if (term.length < 2) {
      closePick();
      return;
    }
    pick.timer = window.setTimeout(() => runPick(input, box, term), 220);
  };

  const choosePick = (index) => {
    const input = pick.input;
    const field = fieldOf(wrapOf(input));
    const entry = pick.items[index];
    if (!input || !field || !entry || entry.disabled || !input.isConnected) return;
    const entries = noteEntries(field.value);
    entries.push(labelFor(entry.item));
    kinds[kindKey(entry.item.name, entry.item.vendor)] = entry.item.sample ? 1 : 0;
    input.value = '';
    closePick();
    writeNote(field, entries);
    if (input.disabled) closeSheet(true);
    else input.focus();
  };

  const removeChip = (button) => {
    const wrap = wrapOf(button);
    const field = fieldOf(wrap);
    const input = inputOf(wrap);
    if (!field) return;
    const entries = noteEntries(field.value);
    const index = parseInt(button.getAttribute('data-cv-chip-remove') || '-1', 10);
    if (index < 0 || index >= entries.length) return;
    entries.splice(index, 1);
    closePick();
    writeNote(field, entries);
    // Su telefono, fuori dal pannello, niente tastiera che si apre da sola.
    const mobile = sheetQuery && sheetQuery.matches;
    if (input && !input.disabled && (!mobile || sheet.picker)) input.focus();
  };

  // Pannello a tutto schermo su telefono: grande quanto la parte visibile sopra la tastiera, sopra il totale e il bottone
  // del carrello. Si usa il visualViewport anche per larghezza e lato sinistro: se la pagina è ingrandita o spostata di lato,
  // il pannello resta comunque tutto dentro lo schermo (Fatto e la × sempre visibili).
  const SHEET_VARS = ['--cv-sheet-left', '--cv-sheet-top', '--cv-sheet-w', '--cv-sheet-h'];
  const sizeSheet = () => {
    const picker = sheet.picker;
    if (!picker) return;
    const view = window.visualViewport;
    const values = view
      ? [view.offsetLeft, view.offsetTop, view.width, view.height]
      : [0, 0, document.documentElement.clientWidth, window.innerHeight];
    SHEET_VARS.forEach((name, i) => picker.style.setProperty(name, Math.round(values[i]) + 'px'));
  };

  const openSheet = (input) => {
    if (!sheetQuery || !sheetQuery.matches) return;
    const picker = input.closest('[data-cv-picker]');
    if (!picker || sheet.picker === picker) return;
    if (sheet.picker) closeSheet(false);
    sheet.picker = picker;
    picker.classList.add('is-sheet');
    document.documentElement.classList.add('cv-sheet-open');
    sizeSheet();
  };

  function closeSheet(reveal) {
    const picker = sheet.picker;
    sheet.picker = null;
    document.documentElement.classList.remove('cv-sheet-open');
    if (!picker) return;
    picker.classList.remove('is-sheet');
    SHEET_VARS.forEach((name) => picker.style.removeProperty(name));
    closePick();
    const input = picker.querySelector('[data-cv-pick-input]');
    if (input) {
      input.value = '';
      if (document.activeElement === input) input.blur();
    }
    if (reveal !== false && picker.isConnected) {
      const wrap = wrapOf(picker);
      if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ block: 'nearest' });
    }
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', sizeSheet);
    window.visualViewport.addEventListener('scroll', sizeSheet);
  }
  if (sheetQuery) {
    const onSheetQuery = () => {
      if (!sheetQuery.matches && sheet.picker) closeSheet(false);
    };
    if (sheetQuery.addEventListener) sheetQuery.addEventListener('change', onSheetQuery);
    else if (sheetQuery.addListener) sheetQuery.addListener(onSheetQuery);
  }

  document.addEventListener('focusin', (event) => {
    const input = event.target;
    if (input && input.matches && input.matches('[data-cv-pick-input]')) openSheet(input);
  });

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (input && input.matches && input.matches('[data-cv-pick-input]')) schedulePick(input);
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target;
    if (!input || !input.matches || !input.matches('[data-cv-pick-input]')) return;
    // Invio non deve mai inviare il modulo del carrello.
    if (event.key === 'Enter') {
      event.preventDefault();
      if (pick.input === input && pick.box && !pick.box.hidden && pick.active >= 0) choosePick(pick.active);
      return;
    }
    const open = pick.input === input && pick.box && !pick.box.hidden;
    if (event.key === 'Escape') {
      event.preventDefault();
      if (open) closePick();
      else if (sheet.picker) closeSheet(true);
      return;
    }
    if (!open) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (!pick.items.length) return;
      event.preventDefault();
      const step = event.key === 'ArrowDown' ? 1 : -1;
      let next = pick.active;
      for (let i = 0; i < pick.items.length; i += 1) {
        next = (next + step + pick.items.length) % pick.items.length;
        if (!pick.items[next].disabled) break;
      }
      setActive(next);
    }
  });

  // La casella non perde il cursore quando si tocca una voce dell'elenco.
  document.addEventListener('mousedown', (event) => {
    if (event.target.closest && event.target.closest('.cv-pick__item')) event.preventDefault();
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    const done = target.closest ? target.closest('[data-cv-sheet-done]') : null;
    if (done) {
      event.preventDefault();
      closeSheet(true);
      return;
    }
    const remove = target.closest ? target.closest('[data-cv-chip-remove]') : null;
    if (remove) {
      event.preventDefault();
      removeChip(remove);
      return;
    }
    const option = target.closest ? target.closest('.cv-pick__item') : null;
    if (option) {
      const index = pick.items.findIndex((entry) => entry.node === option);
      if (index >= 0) choosePick(index);
      return;
    }
    if (pick.box && !pick.box.hidden && !(target.closest && target.closest('.cv-cartnote'))) closePick();
  });

  const watchCart = () => {
    [DRAWER, PAGE].forEach((selector) => {
      const container = document.querySelector(selector);
      if (!container || container.dataset.cvWatched) return;
      container.dataset.cvWatched = '1';
      new MutationObserver(restoreNote).observe(container, { childList: true });
    });
  };

  /* ---------- Scheda prodotto: richiesta su WhatsApp quando il formato è esaurito ---------- */

  const initRequest = () => {
    const link = document.querySelector('[data-cv-request]');
    const root = document.querySelector('.caveau-product-layout');
    if (!link || !root || link.dataset.cvReady) return;
    link.dataset.cvReady = '1';

    const sync = () => {
      const button = root.querySelector('.main-product_atc-btn');
      const soldOut = !!button && button.disabled;
      if (link.hidden === soldOut) link.hidden = !soldOut;
      if (!soldOut) return;
      const checked = root.querySelector('product-variants input[type="radio"]:checked');
      const size = checked ? ' ' + checked.value : '';
      const text = (link.dataset.message || '').trim() + ' ' + (link.dataset.title || '') + size + ' ' + (link.dataset.url || '');
      const href = 'https://wa.me/' + link.dataset.number + '?text=' + encodeURIComponent(text.trim());
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    };

    new MutationObserver(sync).observe(root, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
    root.addEventListener('change', sync);
    sync();
  };

  /* ---------- Pagina campioni: ricerca tra tutti i profumi con campione ---------- */

  const initSampleSearch = () => {
    const box = document.querySelector('[data-cv-sample-search]');
    if (!box || box.dataset.cvReady) return;
    box.dataset.cvReady = '1';
    const input = box.querySelector('input');
    const results = box.querySelector('[data-cv-sample-results]');
    const status = box.querySelector('[data-cv-sample-status]');
    if (!input || !results || !status) return;
    const browse = () => document.querySelectorAll('[data-cv-sample-browse]');
    let controller = null;
    let timer = 0;

    const reset = () => {
      results.innerHTML = '';
      results.hidden = true;
      status.textContent = '';
      browse().forEach((element) => { element.hidden = false; });
    };

    const run = () => {
      const term = input.value.trim();
      if (controller) controller.abort();
      if (term.length < 2) {
        reset();
        return;
      }
      controller = new AbortController();
      const url = (box.dataset.url || '/search') + '?q=' + encodeURIComponent(term) +
        '&type=product&options%5Bprefix%5D=last&section_id=caveau-sample-results';
      fetch(url, { signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error('search');
          return response.text();
        })
        .then((markup) => {
          const doc = new DOMParser().parseFromString(markup, 'text/html');
          const list = doc.querySelector('[data-cv-sample-list]');
          const found = list ? list.querySelectorAll('li').length : 0;
          results.innerHTML = found ? list.innerHTML : '';
          results.hidden = !found;
          status.textContent = found ? '' : box.dataset.emptyText || '';
          browse().forEach((element) => { element.hidden = true; });
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          reset();
          status.textContent = box.dataset.errorText || '';
        });
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(run, 350);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        window.clearTimeout(timer);
        run();
      }
    });
  };

  const init = () => {
    watchCart();
    enhanceNotes();
    initRequest();
    initSampleSearch();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
